module.exports = __webpack_public_path__ + "img/255.7afe8112.jpg";